// extracted by mini-css-extract-plugin
module.exports = {"fileInput":"FileInput__fileInput","container":"FileInput__container","holder":"FileInput__holder"};